import { PrimaryButton } from "office-ui-fabric-react";
import * as React from "react";
export var SuccessPanel = function SuccessPanel(props) {
  return React.createElement("div", {
    className: "center"
  }, React.createElement("div", null, React.createElement("div", null, props.strings.CopySuccesfull, React.createElement("br", null), props.webURL && React.createElement("span", {
    dangerouslySetInnerHTML: {
      __html: props.strings.NewFile.replace("{webURL}", props.webURL)
    }
  })), React.createElement("br", null), React.createElement("br", null), props.buttonClick && React.createElement("div", {
    className: "buttonContainer"
  }, React.createElement(PrimaryButton, {
    text: props.strings.Close,
    onClick: props.buttonClick
  }))));
};